import { render, staticRenderFns } from "./FUN.vue?vue&type=template&id=cbcafa62"
import script from "./FUN.vue?vue&type=script&lang=js"
export * from "./FUN.vue?vue&type=script&lang=js"
import style0 from "./FUN.vue?vue&type=style&index=0&id=cbcafa62&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbcafa62')) {
      api.createRecord('cbcafa62', component.options)
    } else {
      api.reload('cbcafa62', component.options)
    }
    module.hot.accept("./FUN.vue?vue&type=template&id=cbcafa62", function () {
      api.rerender('cbcafa62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Study/FUN.vue"
export default component.exports